import { render, staticRenderFns } from "./UserCreateUpdate.view.vue?vue&type=template&id=4a54fd50&scoped=true&"
import script from "./UserCreateUpdate.view.vue?vue&type=script&lang=js&"
export * from "./UserCreateUpdate.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54fd50",
  null
  
)

export default component.exports